export const eventDrillDownPageHeaderMessagesEn = {
  'projects.cohortBuilderPage.eventDrillDownPage.title': 'Event data: {eventName}',
  'projects.cohortBuilderPage.eventDrillDownPage.logicDrilldown': 'Logic drilldown',
};
